import { Kmehrelement } from './kmehrelement';

export class Kmehrid extends Kmehrelement {
    private allowedAttributes = ['s', 'sv', 'sl'];
    private allowedAttrValues = {
        s: ['LOCAL', 'ID-KMEHR', 'ID-PATIENT', 'ID-HCPARTY', 'ID-INSURANCE', 'INSS']
    };
    public s = '';
    public sv = '1.0';
    public sl = '';

    fromJson(json: any) {
        if (!json) {
            return;
        }
        const jsonKeys = Object.keys(json);
        if (jsonKeys && Array.isArray(jsonKeys)) {
            jsonKeys.forEach(key => {
                switch (key) {
                    case 's':
                        {
                            this.s = json[key];
                        }
                        break;
                    case 'sv':
                        {
                            this.sv = json[key];
                        }
                        break;
                    case 'sl':
                        {
                            this.sl = json[key];
                        }
                        break;
                    case 'value':
                        {
                            this.value = json[key];
                        }
                        break;
                }
            });
        }
    }
}
